import {inQueue, getQueueClone, outQueue} from './queue.js'
import {getQueueRunStatus, nextQueue, observePopup} from "./event.js";

/**
 * POPUP QUEUE 대기열에 팝업을 추가합니다.
 * <h3>팝업 우선순위 리스트</h3>
 * <ul>
 *     <li>되는시간 팝업: .js-whattime-popup-wrap (우선순위: 5)</li>
 *     <li>PC앱 설치 팝업: #desktopDownloadGuideArea (우선순위: 10) (되는 시간 이후 실행됨.)</li>
 *     <li>선택 업데이트 팝업: .no-logo-SelectUpdate (우선순위: 20)</li>
 *     <li>패스워드 변경 팝업: #passwordExpiration (우선순위: 30)</li>
 *     <li>초대 팝업: #mainInvitePopup (우선순위: 50)</li>
 *     <li>다른 프로젝트 구경하기: .js-public-go-popup (우선순위: 70)</li>
 *     <li>공지 팝업: notice (우선순위: 100)</li>
 *     <li>튜토리얼: #tutorialLayer (우선순위: 200)</li>
 *     <li>유저 가이딩: #userguiding (우선순위: 900)</li>
 *     <li>브라우저 팝업: browserPopup (우선순위: 990)</li>
 * </ul>
 * @param target 팝업 식별자
 * @param priority 우선순위
 * @param checkChildRemove 자식 노드 제거를 체크할지 유무
 * @param executeCallback 팝업 실행 콜백
 */
function inputPopupQueue(target, priority, checkChildRemove, executeCallback) {
    if (typeof checkChildRemove === 'function' && executeCallback === undefined) {
        executeCallback = checkChildRemove;
        checkChildRemove = true;
    }

    Mutil.mlog("[INPUT POPUP QUEUE]", target, priority);
    if (Often.null2Void(target) === "") {
        // 팝업 큐에 입력되는 팝업 대상이 없습니다. (target 누락 상황)
        console.error("There is no target of the popup inputting to the popup queue.");
        return;
    }

    const oldQueue = getQueueClone();
    if (Often.null2Void(priority) === "") priority = oldQueue[oldQueue.length - 1].priority + 1;

    inQueue(target, priority, checkChildRemove, executeCallback);

    const newQueue = getQueueClone();
    const queueRunStatus = getQueueRunStatus();

    if (!queueRunStatus && newQueue.length > 0) {
        observePopup(outQueue(), nextQueue);
    }
    Mutil.mlog("[POPUP QUEUE STATUS]", newQueue, queueRunStatus);
}

export {inputPopupQueue, getQueueClone}
